import * as React from 'react';
import { PortWidget } from '@projectstorm/react-diagrams-core';
import styled from '@emotion/styled';
export const PortLabel = styled.div`
		display: flex;
		margin-top: 1px;
		align-items: center;
		width:100%;
`;
export const Label = styled.div`
		padding: 0 5px;
		flex-grow: 1;
`;
export const Port = styled.div`
        font-size: 11px;
        flex:auto;
		height: ${p => p.height}px;
		background: rgba(white, 0.1);
		text-align:center;
		
		&:hover {
			background: rgba(256, 256, 256, 0.6);
		}
		cursor:pointer;
	`;
export class UnBinaryPortLabelWidget extends React.Component {
  render() {
    const port = /*#__PURE__*/React.createElement(PortWidget, {
      engine: this.props.engine,
      port: this.props.port
    }, /*#__PURE__*/React.createElement(Port, {
      width: this.props.width,
      height: 20
    }));
    const label = /*#__PURE__*/React.createElement(Label, null, this.props.port.getOptions().label);
    return /*#__PURE__*/React.createElement(PortLabel, null, port);
  }

}